import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

class TableSorterComponent extends Component {
	constructor () {
		super("tableSorterComponent");
	}




		
	beforeRender () {

		let tableContentList = this.get("tableContentList");

		console.log("*************", Shark.activePage.__store, this.__store, tableContentList);

		if (tableContentList && tableContentList.length > 0) {
			const sortField = this.get("listSortField");
			const sortType = this.get("sortType");
			
			// if (sortField && sortType) {
			// switch (sortField) {
				switch (sortType) {
					case "boolean":
						tableContentList.sort(function (a, b) {
							if (!a[sortField] && b[sortField]) {
								return 1;
							}
							else if (a[sortField] && !b[sortField]) {
								return -1;
							}
							else {
								if (a.name > b.name) {
									return 1;
								}
								else if (a.name < b.name) {
									return -1;
								}
							}
						});
						break;
					case "date":
						tableContentList.sort(function (a, b) {
							// console.log(a[sortField], b[sortField])
							if (a[sortField] === "" && b[sortField] !== "" || a[sortField] === undefined && b[sortField] !== undefined) {
								return 1;
							}
							else if (a[sortField] !== "" && b[sortField] === "" || a[sortField] !== undefined && b[sortField] === undefined) {
								return -1;
							}
							else {
								if (a[sortField] > b[sortField]) {
									return 1;
								}
								else if (a[sortField] < b[sortField]) {
									return -1;
								}
							}
						});
						break;
					case "number":
						if (sortField.indexOf(".") === -1) {
							tableContentList.sort((a, b) => a[sortField] - b[sortField]);
						}
						else {
							tableContentList.sort(function (a, b) {
								const aProp = Utils.getDeepProperty(a, sortField);
								const bProp = Utils.getDeepProperty(b, sortField);

								return aProp - bProp;
							});
						}
						break;
					default:
						if (sortField.indexOf(".") === -1) {
							tableContentList.sort(function (a, b) {
								if (a[sortField].toLowerCase() > b[sortField].toLowerCase()) {
									return 1;
								}
								else if (a[sortField].toLowerCase() < b[sortField].toLowerCase()) {
									return -1;
								}
							});
						}
						else {
							tableContentList.sort(function (a, b) {
								const aProp = Utils.getDeepProperty(a, sortField);
								const bProp = Utils.getDeepProperty(b, sortField);

								if (aProp > bProp || aProp === undefined && bProp !== undefined) {
									return 1;
								}
								else if (aProp < bProp || aProp !== undefined && bProp === undefined) {
									return -1;
								}
							});
						}
						break;
				// }
			
			}

			if (["constructionSiteListView", "constructionSiteCardListView"].indexOf(Shark.activePage.id)) {
				tableContentList.forEach((item, index) => {
					item.__index = index;
					item.__displayIndex = index + 1;
				});
			}
		}
	}

	init () {
		this.set({
			listSortField: "",
			sortStatus: {},
			tableContentList: [],
		});
	}

	setSortField (sortField, columnIndex, sortType) {
		const sortStatus = {
			[`sortBy_${sortField}`]: true,
		}
		sortStatus.tableClass = "table-sort-th-" + columnIndex;

		this.set({
			listSortField: sortField,
			sortStatus,
			sortType,
		});
	}

	//Dave: Bello il seutp, ma al beforeLoad la tabella non c'è sullo schermo quindi non posso sapere quale posizione occupa il campo.. per farla bene devo astrarre la struttura e gestirla nel componente
	// setup (sortField, tableSelector = "") {
	// 	if (tableSelector !== "") {
	// 		tableSelector = " " + tableSelector;
	// 	}

	// 	const allTableHeaders = Array.from(document.querySelectorAll(tableSelector + "th"));
	// 	if (allTableHeaders.length > 0) {
	// 		const activeHeaderIndex = allTableHeaders.findIndex(item => item.dataset.sortField === sortField);
	// 		const activeHeader = allTableHeaders[activeHeaderIndex];
				
	// 		const sortStatus = {
	// 			[`sortBy_${sortField}`]: true,
	// 		}
	// 		sortStatus.tableClass = "table-sort-th-" + activeHeaderIndex;

	// 		this.set({
	// 			listSortField: sortField,
	// 			sortStatus,
	// 			sortType: activeHeader.dataset.sortType || "string",
	// 		});
	// 	}
	// });

	tableSortBtn_clickHandler (event, data) {
		if (this.get("listSortField") === data.sortField) {
			return;//Se il campo di ordinamento è lo stesso non lo riordino.
		}

		const sortStatus = this.get("sortStatus");

		for (let currProp in sortStatus) {
			sortStatus[currProp] = false;
		}
		sortStatus[`sortBy_${data.sortField.replace(/\./g, "_")}`] = true;

		const allTableHeaders = Array.from(document.querySelectorAll("th"));
		const activeHeaderIndex = allTableHeaders.indexOf(event.currentTarget);
		sortStatus.tableClass = "table-sort-th-" + activeHeaderIndex;

		this.set({
			listSortField: data.sortField,
			sortStatus,
			sortType: data.sortType || "string"
		});
		Shark.render();
	}

}

const tableSorterComponent = new TableSorterComponent();

Shark.registerComponent(tableSorterComponent);

export { tableSorterComponent };
